// extracted by mini-css-extract-plugin
export var arrow = "_hn-1";
export var content = "_hn-0";
export var highlighted = "_hn-2";